<a class="d-flex flex-row best-performing-item-container" (click)="openPostPage()">
    <div class="post-summarize">
      <div class="row">
        <div class="col-sm-12">
          <div class="d-flex flex-nowrap flex-row">
            <div class="d-flex best-performing-img-wrapper mr-2">
              <blurry-backdrop-image [image]="platformReach.imageUrl" class="best-performing-img"></blurry-backdrop-image>
            </div>
            <div class="d-flex flex-column exposure-text">
              <a class="exposure-text-wrapper">{{platformReach.title}}</a>
              <span class="exposure-date">{{formatPublishData(platformReach.date)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="post-kpi">
      <div class="d-flex flex-row full-height">
        <div class="d-flex platform-icon full-height align-items-center justify-content-center">
          <img src="{{getPlatformIcon(platformReach.platform)}}"
               onerror="this.onerror=null;this.src='assets/images/No_Image.png'"
               width="21.3" height="21.3">
        </div>
        <div class="d-flex engagement">
          <div class="exposure-statictis d-flex justify-content-start align-items-center">
            <span placement="bottom"
                  ngbTooltip="{{'info_box.influencer.insight_engagement' | translate}}">
              {{platformReach.engagement | thousandNumberSuffix:1}}
            </span>
          </div>
        </div>
        <div class="d-flex reach">
          <div class="exposure-statictis d-flex justify-content-start align-items-center">
            <span placement="bottom"
                  ngbTooltip="{{'info_box.influencer.insight_reach' | translate}}">
              {{platformReach.reach | thousandNumberSuffix:1}}
            </span>
          </div>
        </div>
        <div class="d-flex impact">
          <div class="exposure-statictis d-flex justify-content-start align-items-center">
            <span placement="bottom"
                  ngbTooltip="{{'info_box.influencer.insight_impact' | translate}}">
              {{platformReach.impact | percentNumberSuffix}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </a>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/list-platform-reach/platform-reach-item/platform-reach-item.component.html